import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnersQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.list({
		page: e,
		...r
	}),
	key: "partners"
});
//#endregion
export { r as useAdminPartnersQuery };
